import type { ReelWinTuning } from "@slot/mechanics-reels";

/**
 * The payline needle through a win's cells (`ReelPaylineEffect`), the Cocos title's values
 * (`assets/scripts/game/tuning/reelWinTuning.ts`): drawn in a quarter second after a short lead-in, held 0.6 s, faded.
 * 50 tall, the needle's 398×44 slices are 452 wide (a little over two reels); its tips reach 220 past the end cells.
 */
export const REEL_WIN_TUNING: ReelWinTuning = {
  payline: {
    startDelaySeconds: 0.08,
    expandSeconds: 0.25,
    staggerSeconds: 0,
    expandEasing: "quadOut",
    holdSeconds: 0.6,
    fadeOutSeconds: 0.3,
    fadeEasing: "quadIn",
    thicknessPixels: 50,
    endOverhangPixels: 220,
  },
};
